import { useMutation } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

const useCreateThread = (caseId: string) => {
  const { getFetchConfig } = useGetFetchConfig();

  const createThread = async (question: string) => {
    const fetchConfig = getFetchConfig({
      method: FetchMethod.POST,
      data: {
        question,
      },
    });

    const response = await fetch(`${APIBaseChronos}/api/case/${caseId}/thread`, fetchConfig);
    if (!response.ok) {
      throw new Error('Creating thread failed');
    }
    return await response.json();
  };

  return useMutation((question: string) => createThread(question));
};

export default useCreateThread;
